var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPelota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tfhm581kga",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h50v50H0V0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tfhm581kga)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M33.438 45.015c-3.039-3.445-5.82-7.542-8.255-12.118 2-.648 4.089-1.19 6.24-1.61 4.996-.971 9.992-1.212 14.57-.714-1.732 6.522-6.428 11.85-12.555 14.442m-22.936-3.857c2.964-2.844 6.951-5.289 11.568-7.137 2.365 4.506 5.052 8.59 7.988 12.1-1.623.388-3.316.6-5.058.6-5.567 0-10.65-2.107-14.498-5.563M13.008 6.9c.495 2.88 1.127 5.784 1.901 8.656.687 2.55 1.475 5.042 2.347 7.466-4.586.894-9.321.724-13.829-.527.75-6.502 4.38-12.138 9.58-15.595m25.197.843c-3.223 5.928-8.409 10.652-14.7 13.355-1.001.43-2.021.798-3.052 1.117-.885-2.434-1.684-4.941-2.377-7.512-.85-3.15-1.53-6.34-2.028-9.487C18.779 3.977 21.808 3.28 25 3.28c4.887 0 9.494 1.627 13.204 4.465M20.6 31.081c-4.903 1.997-9.162 4.638-12.37 7.711-2.923-3.547-4.74-8.037-4.931-12.937 2.668.673 5.4 1.014 8.136 1.014 2.347 0 4.694-.25 7.003-.742.68 1.692 1.399 3.348 2.162 4.954m29-1.664c.258-1.436.4-2.91.4-4.417 0-.905-.735-1.64-1.64-1.64-.906 0-1.64.735-1.64 1.64 0 .793-.045 1.574-.128 2.344-4.973-.567-10.393-.326-15.795.725-2.456.477-4.839 1.11-7.116 1.873-.722-1.508-1.403-3.064-2.05-4.654 1.069-.339 2.126-.73 3.166-1.175 6.726-2.89 12.313-7.871 15.908-14.124 1.787 1.87 3.26 4.077 4.31 6.557.352.834 1.313 1.225 2.147.87.834-.352 1.224-1.313.872-2.148C44.11 5.993 35.07 0 25 0 11.215 0 0 11.215 0 25s11.215 25 25 25c12.27 0 22.495-8.887 24.597-20.56 0-.005.003-.01.004-.014v-.01",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPelota);
export default __webpack_public_path__ + "static/media/pelota.3a7216d96836d01c96cbb3503acd312c.svg";
export { ForwardRef as ReactComponent };